import { useEffect, useState } from "react";
import api from "@/lib/api";
import GenericCrudPage from "./GenericCrudPage";

const TYPES = [
  { value: "payable", label: "Payable (to vendor)" },
  { value: "receivable", label: "Receivable (from client)" },
];
const STATUS = [
  { value: "pending", label: "Pending" },
  { value: "paid", label: "Paid" },
  { value: "overdue", label: "Overdue" },
  { value: "cancelled", label: "Cancelled" },
];

export default function InvoicesPage() {
  const [projects, setProjects] = useState([]);
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data));
    api.get("/vendors").then((r) => setVendors(r.data));
  }, []);

  return (
    <GenericCrudPage
      testid="invoices"
      overline="ACCOUNTS"
      title="Invoices"
      description="Track payable and receivable invoices across projects and vendors."
      endpoint="/invoices"
      defaults={{ invoice_number: "", project_id: "", vendor_id: "", invoice_type: "payable", amount: 0, invoice_date: "", due_date: "", status: "pending", notes: "" }}
      fields={[
        { name: "invoice_number", label: "Invoice #", type: "text" },
        { name: "invoice_type", label: "Type", type: "select", options: TYPES },
        { name: "project_id", label: "Project", type: "select", options: projects.map((p) => ({ value: p.id, label: p.name })) },
        { name: "vendor_id", label: "Vendor", type: "select", options: vendors.map((v) => ({ value: v.id, label: v.name })) },
        { name: "amount", label: "Amount (₹)", type: "number" },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "invoice_date", label: "Invoice Date", type: "date" },
        { name: "due_date", label: "Due Date", type: "date" },
        { name: "notes", label: "Notes", type: "textarea", colSpan: 2 },
      ]}
      columns={["invoice_number", "invoice_type", "amount", "status", "due_date"]}
    />
  );
}
